import React from 'react';
import { Box, Container, Stack } from '@mui/material';

const FullscreenLayout = ({ children, fullHeight }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.main',
        display: 'flex',
        flex: 1,
        justifyContent: 'center',
        height: fullHeight ? '100dvh' : 'auto',
      }}
    >
      <Container
        sx={{
          paddingY: 3,
        }}
      >
        <Stack component="main" id="content" sx={{ height: '100%' }}>
          {children}
        </Stack>
      </Container>
    </Box>
  );
};

export default FullscreenLayout;
